import { create } from 'zustand';
import { MODES } from '@scio3/shared-types';

/** Subset of MODES used in schedule sidebar */
export type ScheduleSidebarMode = typeof MODES.DEFAULT | typeof MODES.SHARE_WITH_ME;

/** GAP-03: Search scope controls whether search queries current folder or all schedules */
export type SearchScope = 'all' | 'folder';

interface ScheduleSidebarState {
  searchText: string;
  mode: ScheduleSidebarMode;
  /** GAP-03: Whether to search all schedules or only within current folder */
  searchScope: SearchScope;
  collapsed: boolean;
  /** Signal to scroll sidebar to a specific schedule after breadcrumb navigation */
  scrollToItemId: string | null;
  setSearchText: (text: string) => void;
  setMode: (mode: ScheduleSidebarMode) => void;
  setSearchScope: (scope: SearchScope) => void;
  toggleCollapsed: () => void;
  clearSearch: () => void;
  requestScrollToItem: (id: string) => void;
  clearScrollToItem: () => void;
}

export const useScheduleSidebarStore = create<ScheduleSidebarState>((set) => ({
  searchText: '',
  mode: MODES.DEFAULT,
  searchScope: 'folder',
  collapsed: false,
  scrollToItemId: null,
  setSearchText: (searchText) => set({ searchText }),
  setMode: (mode) => set({ mode, searchText: '' }),
  setSearchScope: (searchScope) => set({ searchScope }),
  toggleCollapsed: () => set((s) => ({ collapsed: !s.collapsed })),
  clearSearch: () =>
    set((s) => ({
      searchText: '',
      searchScope: 'folder',
      mode: s.mode === MODES.SHARE_WITH_ME ? MODES.SHARE_WITH_ME : MODES.DEFAULT,
    })),
  requestScrollToItem: (id) => set({ scrollToItemId: id }),
  clearScrollToItem: () => set({ scrollToItemId: null }),
}));
